import { getSyEnv } from "@/apis/gameJump";

const STORAGE_KEY = "yy627_invoice_game_platform";

export const normalizeInvoiceGamePlatform = platform => platform === "yw" ? "yw" : "sy";

export const setInvoiceGamePlatform = platform => {
  const normalized = normalizeInvoiceGamePlatform(platform);
  sessionStorage.setItem(STORAGE_KEY, normalized);
  return normalized;
};

export const getInvoiceGamePlatform = () => normalizeInvoiceGamePlatform(sessionStorage.getItem(STORAGE_KEY));

export const clearInvoiceGamePlatform = () => sessionStorage.removeItem(STORAGE_KEY);

export const getInvoiceGameBaseURL = () => {
  if (getInvoiceGamePlatform() !== "yw") return getSyEnv();
  switch (process.env.VUE_APP_ENV) {
    case "pre":
      return "https://h5-pre.w2you.com";
    case "production":
      return "https://h5.w2you.com";
    default:
      return "https://h5-test.xdi2.cn";
  }
};
